module.exports = __webpack_public_path__ + "static/media/cven.082a25b9.pdf";